import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { IContentLanguage } from '../../fi-content-language-shared/fi-content-language-shared';
import { FiChecklistHelperService } from '@fi-shared/checklist/fi-checklist-helper.service';
import { FiChecklistStoreService } from '@fi-shared/checklist/fi-checklist-store.service';

@Component({
    selector: 'fi-checklist2-translation',
    template: `
        <mat-card class="checklist2-translation-card">
          <!--            todo: use  fi-translation-radio-group -->
          <mat-card-title class="checklist-card-title">{{ 'common.content_language' | fiAppText }}</mat-card-title>
        
          <mat-radio-group [(ngModel)]="selectedLanguageId" (ngModelChange)="changeSelectedLanguageId($event)">
            @for (contentLanguage of availableContentLanguages; track contentLanguage) {
              <mat-radio-button
                [value]="contentLanguage.Id"
                >
                {{ contentLanguage.Name }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </mat-card>
        `,
    styleUrls: ['./fi-checklist2-translation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-translation' },
    standalone: false,
})
export class FiChecklist2TranslationComponent implements OnInit {
    availableContentLanguages: IContentLanguage[] = [];
    selectedLanguageId: number;

    constructor(
        private fiChecklistHelperService: FiChecklistHelperService,
        private fiChecklistStoreService: FiChecklistStoreService,
    ) {}

    ngOnInit() {
        this.setAvailableContentLanguages();
        this.setSelectedLanguageId();
    }

    setAvailableContentLanguages() {
        this.availableContentLanguages = this.fiChecklistStoreService.availableContentLanguages;
    }

    private setSelectedLanguageId() {
        this.selectedLanguageId = this.fiChecklistStoreService.selectedLanguageId;
    }

    changeSelectedLanguageId(languageId: number) {
        this.selectedLanguageId = languageId;
        this.fiChecklistStoreService.selectedLanguageId = languageId;
    }
}
